import Spinner from "components/ui/spinner/Spinner";
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { Provider } from "react-redux";
import { useAppSelector } from "redux/app/hooks";
import "./App.css";
import AppHeader from "./components/Header/AppHeader";
import { store } from "./redux/app/store";
import Routes from "./routes/routes";
import { GlobalStateProviderDesbloqueio } from "contexts/DesbloqueioContext";
import { memo, useEffect, useRef } from "react";
import "react-tabs/style/react-tabs.css";

/**
 * Intervalo de verificacao da versao publicada no CloudFront.
 * Em milissegundos, determina a frequencia do polling de atualizacao.
 */
const APP_UPDATE_CHECK_INTERVAL_MS = 60000;

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBBoxoIhLCR0KQ2A7KuzX-RbjaQM4dPRp4",
  authDomain: "totem-teucard.firebaseapp.com/",
  projectId: "totem-teucard",
  storageBucket: "totem-teucard.appspot.com",
  messagingSenderId: "1091576933706",
  appId: "1:1091576933706:web:54d240e849af9ce74565b3",
};

// Initialize Firebase
initializeApp(firebaseConfig);

const AppWrapper = () => {
  return (
    <Provider store={store}>
      <App />
    </Provider>
  );
};

const HandleApp = memo(() => {
  return (
    <div className="App">
      <AppHeader />
      <div className="App-Content">
        <GlobalStateProviderDesbloqueio>
          <Routes />
        </GlobalStateProviderDesbloqueio>
      </div>
    </div>
  );
});

const App = () => {
  const { loading, title } = useAppSelector((state) => state.loading);
  const currentBuildSignature = useRef<string | null>(null);

  useEffect(() => {
    const preventPinch = (e: TouchEvent) => {
      if (e.touches.length > 1) {
        e.preventDefault();
      }
    };

    document.addEventListener("touchmove", preventPinch, { passive: false });

    return () => {
      document.removeEventListener("touchmove", preventPinch);
    };
  }, []);

  useEffect(() => {
    /**
     * Recupera uma assinatura da build atual publicada.
     * Prioriza o asset-manifest.json e usa index.html como fallback
     * para evitar falha durante janelas curtas de deploy.
     *
     * @returns Assinatura da build atual ou null quando indisponivel.
     */
    const getBuildSignature = async (): Promise<string | null> => {
      try {
        // Tenta buscar o asset-manifest.json com bypass de cache
        const response = await fetch(`/asset-manifest.json?t=${Date.now()}`, {
          cache: "no-store",
          headers: {
            "cache-control": "no-cache",
          },
        });

        if (!response.ok) {
          console.warn(
            `[AutoUpdate] asset-manifest.json indisponível (${response.status}), tentando fallback`
          );
          // Fallback: tenta buscar index.html como indicador de novo deploy
          const indexResponse = await fetch(`/?t=${Date.now()}`, {
            cache: "no-store",
            headers: {
              "cache-control": "no-cache",
            },
          });
          return indexResponse.ok ? `index-${Date.now()}` : null;
        }

        const manifest = await response.json();
        const mainJs = manifest?.files?.["main.js"];
        const entrypoints = Array.isArray(manifest?.entrypoints)
          ? manifest.entrypoints.join("|")
          : "";

        return mainJs || entrypoints || null;
      } catch (error) {
        console.warn(`[AutoUpdate] Erro ao verificar versão:`, error);
        return null;
      }
    };

    /**
     * Compara a assinatura atual do cliente com a assinatura publicada.
     * Quando detecta mudanca de versao, recarrega a aplicacao para
     * garantir que o totem use o build mais recente.
     */
    const checkForNewVersion = async () => {
      try {
        const latestBuildSignature = await getBuildSignature();

        if (!latestBuildSignature) {
          return;
        }

        if (!currentBuildSignature.current) {
          currentBuildSignature.current = latestBuildSignature;
          console.log(
            `[AutoUpdate] Versão inicial registrada:`,
            latestBuildSignature
          );
          return;
        }

        if (currentBuildSignature.current !== latestBuildSignature) {
          console.log(
            `[AutoUpdate] Nova versão detectada! Recarregando aplicação...`
          );
          window.location.reload();
        }
      } catch (error) {
        console.error(`[AutoUpdate] Erro ao verificar atualização:`, error);
      }
    };

    // Executa verificação inicial
    checkForNewVersion();

    // Agenda verificações periódicas
    const intervalId = window.setInterval(
      checkForNewVersion,
      APP_UPDATE_CHECK_INTERVAL_MS
    );

    return () => {
      window.clearInterval(intervalId);
    };
  }, []);

  return (
    <>
      <Spinner loading={loading} title={title}>
        <HandleApp />
      </Spinner>
    </>
  );
};

export default AppWrapper;
